import React, { useState } from 'react';
import { styled } from '@mui/system';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AccodianRoot = styled('div')({
  width: '100%',
});

const Accodian = (props) => {
  const [user] = useState(props.currentUser);

  return (
    <AccodianRoot>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='panel1a-header'
        >
          {props.category}
        </AccordionSummary>
        {props.subCategory.map((item, index) => (
          <Accordion key={index} sx={{ backgroundColor: '#d2e4f5', marginLeft: '34px' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='' id=''>
              {item.key}
            </AccordionSummary>
            {item.images.map((item1, index1) => (
              <AccordionDetails key={index1} sx={{ backgroundColor: 'white' }}>
                <div className='col-md-12 text-left'>
                  {/* Display your checklist question here */}
                  {item1.checklistQuestion}
                </div>
                <div className='col-md-12'>
                  <div className='todo-icon' style={{ fontSize: '1.73em' }}>
                    <span
                      className='mx-8 text-success text-right'
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        props.editRow({
                          id: item1.checklistId,
                          name: item1.checklistQuestion,
                          category: props.category,
                          subCategory: item.key,
                          images: item1.images,
                        });
                      }}
                    >
                      <i className='fas fa-picture-o'></i>
                    </span>
                  </div>
                </div>
              </AccordionDetails>
            ))}
          </Accordion>
        ))}
      </Accordion>
    </AccodianRoot>
  );
};

export default Accodian;
